import bem from 'utils/bem';

export const block = bem('referrals-page');

export const blockFeaturesBox = bem('referrals-features-box');
